const userCenter = {
  appCode: {
    development: '1300616569545662465',
    fat: '1300616569545662465',
    test: '1300616569545662465',
    production: '1300616569545662465'
  }[process.env.VUE_APP_ENV_NAME],
  clientId: {
    development: 'app_aac94ebb',
    fat: 'app_aac94ebb',
    test: 'app_aac94ebb',
    production: 'app_aac94ebb'
  }[process.env.VUE_APP_ENV_NAME],
  js: './user-center/main.js'
};

export default userCenter;
